import script from "./Monitoreo.vue?vue&type=script&setup=true&lang=js"
export * from "./Monitoreo.vue?vue&type=script&setup=true&lang=js"

import "./Monitoreo.vue?vue&type=style&index=0&id=2a971a42&scoped=true&lang=css"
import "./Monitoreo.vue?vue&type=style&index=1&id=2a971a42&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a971a42"]])

export default __exports__